import {sdkPostMessage} from "../../../util";
import {PostMessageResponse} from "../../../types/sdk-response.interface";

export const holdings_wiuk = {
  /**
   * List holdings
   * @param referenceDate
   * @param referenceCurrencyCode
   * @param account
   */
  list(
    referenceDate: string,
    referenceCurrencyCode: string,
    account: { Number: string; Type: string }
  ): Promise<PostMessageResponse> {
    return new Promise((resolve, reject) => {
      sdkPostMessage(
        "wiuk",
        "holdings.list",

        {
          referenceDate,
          referenceCurrencyCode,
          account,
        }
      )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
